import { gql } from 'apollo-angular';
import { DownloadOptionalParameters } from '../catalog-graphql.service';

const DOWNLOAD_CROSS_REFERENCES = (
  downloadParams: DownloadOptionalParameters,
) => {
  return gql`
query downloadCrossReferences {
    downloadCrossReferences(
        crossReferenceDownloadRequest: 
        { 
			      ${
              downloadParams.categorizationSchemeId
                ? 'categorizationSchemeId:' +
                  downloadParams.categorizationSchemeId
                : ''
            }
            ${
              downloadParams.categoryId
                ? 'categoryId:' + downloadParams.categoryId
                : ''
            }
            ${
              downloadParams.searchValue
                ? 'searchValue:' + '"' + downloadParams.searchValue + '"'
                : ''
            }
            ${
              downloadParams.filterDate
                ? 'filterDate:' + '"' + downloadParams.filterDate + '"'
                : ''
            }
            ${
              downloadParams.eppAttributes
                ? 'eppAttributes:' +
                  JSON.stringify(downloadParams.eppAttributes)
                : ''
            }
            ${
              downloadParams.productAttributeNames
                ? 'productAttributeNames:' +
                  JSON.stringify(downloadParams.productAttributeNames)
                : ''
            }
        }
    )
}
`;
};

export default DOWNLOAD_CROSS_REFERENCES;
